import { useTranslation } from '~/app/i18n/client'

type SortOption = {
  key: string
  message: string
  type: 'order' | 'date'
  value?: number
}

export const useLocalisedOrdersSortOptions = (): SortOption[] => {
  const { t } = useTranslation()

  return [
    {
      key: 'newest',
      message: t('filters.newest'),
      type: 'order',
    },
    {
      key: 'oldest',
      message: t('filters.oldest'),
      type: 'order',
    },
    {
      key: 'last_3_months',
      message: t('filters.last3Months'),
      type: 'date',
      value: 3,
    },
    {
      key: 'last_6_months',
      message: t('filters.last6Months'),
      type: 'date',
      value: 6,
    },
    {
      key: 'last_12_months',
      message: t('filters.last12Months'),
      type: 'date',
      value: 12,
    },
  ]
}
